<div class="sw-cms-el-config-moorl-html-tag">
    <sw-cms-mapping-field
        v-model:config="element.config.content"
        value-types="string"
        :label="$tc('sw-cms.elements.moorl-html-tag.label.content')"
    >
        <mt-text-field
            v-model="element.config.content.value"
            :label="$tc('sw-cms.elements.moorl-html-tag.label.content')"
        />
    </sw-cms-mapping-field>
    <mt-text-field
        v-model="element.config.tag.value"
        :label="$tc('sw-cms.elements.moorl-html-tag.label.tag')"
    />
    <mt-text-field
        v-model="element.config.cssClass.value"
        :label="$tc('sw-cms.elements.moorl-html-tag.label.cssClass')"
    />
    <mt-text-field
        v-model="element.config.style.value"
        :label="$tc('sw-cms.elements.moorl-html-tag.label.style')"
    />
</div>